




import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { Document } from "../../../domain/document";
import { FormatReference } from "../../../domain/format";
import { Patient } from "../../../domain/patient";
import ExtraFormatSelectorDialog from "./ExtraFormatSelectorDialog.vue";

@Component({
  components: {
    ExtraFormatSelectorDialog,
  },
})
export default class ExtraDocumentSelectorDialog extends Mixins() {
  data(): any {
    return {
      isLoading: false,
    };
  }
  isLoading: boolean;

  async show(patient: Patient, formats: FormatReference[], getExtraDocument?: (patientId: string, formatId: number) => Promise<Document>): Promise<Document> {
    try {
      const selector = this.$refs.selector as ExtraFormatSelectorDialog;
      const f = await selector.show(formats);
      if (!f) { return null; }
      try {
        this.isLoading = true;
        const d = getExtraDocument
          ? getExtraDocument(patient.id, f.id)
          : DomainRegistry.document.getDocumentRepository().getExtraDocument(patient.id, f.id);
        this.isLoading = false;
        return d;
      } catch (e) {
        this.isLoading = false;
        throw e;
      }
    } catch (e) {
      throw e;
    }
  }
}
